<template>
  <form>
    <div class="row">
      <div class="col">
        <base-select
          label="Organization"
          v-model="value.organizationId"
          :disabled="!canEditBankAccount"
          :options="organizationOptions"
        ></base-select>
      </div>
      <div class="col">
        <base-input
          label="Owner"
        >
          <user-suggest
            :users="users"
            v-model="value.ownerId"
            :disabled="!canEditBankAccount"
          ></user-suggest>
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <base-input
          label="Country"
        >
          <country-suggest
            :countries="countries"
            v-model="value.countryCode3"
            :disabled="!canEditBankAccount"
          ></country-suggest>
        </base-input>
      </div>
      <div class="col">
        <base-input
          label="Currency"
          v-model="value.currency"
          :disabled="true"
        ></base-input>
      </div>
    </div>
    <base-input
      label="Bank Name"
      v-model="value.bankName"
      :disabled="!canEditBankAccount"
      id="bankName" v-on:blur="onBlur($event)" v-bind:valid="valid.bankName"
    ></base-input>
    <div class="row">
      <div class="col">
        <base-input
          label="Account Name"
          v-model="value.accountName"
          :disabled="!canEditBankAccount"
          id="accountName" v-on:blur="onBlur($event)" v-bind:valid="valid.accountName"
        ></base-input>
      </div>
      <div class="col">
        <base-input
          label="Account Number"
          v-model="value.accountNumber"
          :disabled="!canEditBankAccount"
          id="accountNumber" v-on:blur="onBlur($event)" v-bind:valid="valid.accountNumber"
        ></base-input>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <base-input
          label="SWIFT"
          v-model="value.swift"
          :disabled="!canEditBankAccount"
          id="swift" v-on:blur="onBlur($event)" v-bind:valid="valid.swift"
        ></base-input>
      </div>
      <div class="col">
        <base-input
          label="IBAN/Routing Number"
          v-model="value.routingNumber"
          :disabled="!canEditBankAccount"
          id="routingNumber" v-on:blur="onBlur($event)" v-bind:valid="valid.routingNumber"
        ></base-input>
      </div>
    </div>
    <div class="row" v-if="canAdminBankAccount">
      <div class="col-md-6">
        <base-select
          label="Security"
          v-model="value.security"
          :disabled="!canAdminBankAccount"
          :options="securityOptions"
        ></base-select>
      </div>
    </div>
  </form>
</template>
<script>
import { computed, reactive, ref, watch } from '@vue/composition-api'
import { What, Verb, can }  from '@/rights/rights.js'
import BaseInput from '@/components/Forms/BaseInput.vue'
import BaseSelect from '@/components/Forms/BaseSelect.vue'
import CountrySuggest from '@/components/Forms/CountrySuggest.vue'
import UserSuggest from '@/components/Forms/UserSuggest.vue'

export default {
  components: {
    BaseInput,
    BaseSelect,
    CountrySuggest,
    UserSuggest
  },
  props: {
    countries: Array,
    organizations: Array,
    ownerId: String,
    users: Array,
    value: Object,
    valid: Object
  },
  setup(props, context) {
    watch(
      () => props.value.countryCode3,
      (to, from) => {
        // console.log('countryCode3 changed', to, from)
        updateCurrencies(to)
    })

    watch(
      () => props.organizations,
      (to, from) => {
        // console.log('organizations changed', to, from)
        if (to != undefined && to.length == 1) {
          props.value.organizationId = to[0].id
        }
    })

    const currencies = ref([])
    
    function updateCurrencies(to) {
      // console.log('updateCurrencies', to)
      let data = props.countries.find(e => e.countryAlpha3 == to)
      if (data) {
        currencies.value = data.currencies
        if (props.value) {
          props.value.currency = data.currencies[0].code
        }
      }
    }

    // Rights
    const canAdminBankAccount = computed(() => {
      return can(Verb.ADMIN, What.BANKACCOUNT, {
        ownerId: props.ownerId
      })
    })
    
    const canEditBankAccount = computed(() => {
      return can(Verb.EDIT, What.BANKACCOUNT, {
        ownerId: props.ownerId
      })
    })

    // Options
    const organizationOptions = computed(() => {
      return props.organizations.map(e => {
        return {
          id: e.id,
          value: e.name
        }
      })
    })

    const securityOptions = [
      { id: 'review', value: 'review'},
      { id: 'pending', value: 'pending'},
      { id: 'approved', value: 'approved'},
      { id: 'hold', value: 'hold'}
    ]

    function onBlur(value) {
      context.emit('blur', value)
    }
    
    return {
      canAdminBankAccount,
      canEditBankAccount,
      currencies,
      organizationOptions,
      securityOptions,
      onBlur
    }
    
  },
}
</script>